module.exports = __webpack_public_path__ + "img/taiwan-startups.585a87b6.png";